export default __webpack_public_path__ + "static/media/fastener-placement-rectangle-3-breaks.b9b39b58.webp";